import { ComponentPropsWithoutRef } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { Button } from '@givebutter/primitives/button';
import { faRotateRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface ReactQueryErrorBoundaryProps extends ComponentPropsWithoutRef<'div'> {}

const ReactQueryErrorBoundary = ({ className, children = null }: ReactQueryErrorBoundaryProps) => (
    <QueryErrorResetBoundary>
        {({ reset }) => (
            <ErrorBoundary
                onReset={reset}
                fallbackRender={({ resetErrorBoundary }) => (
                    <div
                        className={twMerge(
                            'flex flex-col items-center justify-center gap-4',
                            className,
                        )}
                    >
                        <p className={'font-medium'}>Something went wrong!</p>
                        <Button variant="solid" size={'sm'} onClick={() => resetErrorBoundary()}>
                            <p>Try Again</p>
                            <FontAwesomeIcon icon={faRotateRight} />
                        </Button>
                    </div>
                )}
            >
                {children}
            </ErrorBoundary>
        )}
    </QueryErrorResetBoundary>
);

export { ReactQueryErrorBoundary };
